import { createSelector } from 'reselect';
import defaultReturn from './defaultReturn';
import defaultSelectorProps from './memoizedOptions';

const selector = (dependencies, handler = defaultReturn, options = defaultSelectorProps) => {
    return createSelector(dependencies, handler, options);
};

export default selector;
